import { IntegrationServices } from '@sequencehq/api'

import { CustomerLedgerIntegration } from 'Invoices/hooks/useCustomerLedgerIntegrations'

export const setDefaultExternalIds = (
  integrations: CustomerLedgerIntegration[]
): Array<{ key: IntegrationServices; value: string }> => {
  return integrations.map(integration => {
    return {
      key: integration.id,
      value: integration.defaultLedgerAccount ?? ''
    }
  })
}
